var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"content-page"}},[_vm._t("content"),_c('content-footer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }